namespace Areas.Dialogs {
    "use strict";

    export class VendorReturnReasonDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("VendorReturnReason", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#VendorReturnReasonForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {
                const newData: any = form.option("formData");
                this.close(DialogResult.Ok, newData.ReturnReason);
            }
           
        }
    }

}
